import React, { Component } from 'react';
import LineworxClient from '../lineworxClient';
import { CSSTransition } from 'react-transition-group';
import Dropdown from 'react-dropdown';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Section from '../components/Section/Section';
import { handleSorting } from '../handleSorting';
import { sortByCrew } from '../handleSorting';
// Import module css
import styles from './Crew.module.css';

/* eslint-disable */
let reg = /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
/* eslint-enable */

class Crew extends Component {
    
  constructor(props) {
    super(props);

    this.state={
      updating: 0,

      utilsForDropdown: [],
      selectedUtility: '',

      searchString: '',

      selectedStatus: 'Active',
      crew: [],
      filteredCrew: [],
      showForeman:false,
      showAddUser: false,
      showEditUser: false,
      workingForemen:[],
      workingForeForDropdown:[],
      foremenForDropdown:[],
      genericForemenToUseForDropdown:[],
      roleId: LineworxClient.getTokenDecoded.roleId,
      emailError:false,
      canSave:false,
      //sort_dir:"asc",
      //sort_col: "first_name"
    }

    this.updateSearchString = this.updateSearchString.bind(this);
    this.updateSelectedStatus = this.updateSelectedStatus.bind(this);
    this.showAddUserModal = this.showAddUserModal.bind(this);
    this.updateOrAddUser = this.updateOrAddUser.bind(this);
    this.showEditUserModal = this.showEditUserModal.bind(this)
    this.dismissModal = this.dismissModal.bind(this)
    this.validateEmail=this.validateEmail.bind(this);
    this.checkIsDirty=this.checkIsDirty.bind(this);
    this.handleSorting = handleSorting.bind(this);
    this.sortBy = sortByCrew.bind(this);
  }

  handleSelectUtility = (option) => {
    const selectedUtility = option.label;
    this.setState({
      selectedUtility
    })
  }

  updateSearchString(event) {
    this.setState({ searchString: event.target.value }, () => {
      const val = this.state.searchString;
      
      if (val.length < 5) {
        this.autocompleteSearchThrottled(val);
      } else {
        this.autocompleteSearchDebounced(val);
      }
    });
  }

  componentDidMount(){
    if(LineworxClient.canShowCrew()){
      this.getCrew();
      this.getConfigurableRoles();
      this.getForemen();
      this.loadSortingDefaults();
        
    }
  }

  async getCrew() {
    this.setState({
      updating: true
    })

    const crew = await LineworxClient.getAllCrew();
    if(crew.body) {
       
        this.setState({
            crew:crew.body,
            updating: false
        }, () => {
          // Get the sort by value from local storage and sort the jobs array based on it
        const sortByValue = localStorage.getItem('sortByCrew');
        this.sortBy(sortByValue);
        //this.sortBy('first_name');
        });
    }
    else {
      this.setState({
        updating: false
      });
    }   
  }

  async getForemen() {
    this.setState({
      updating: true
    })

    const fores = await LineworxClient.getForemen();
    const workingForemen = await LineworxClient.getWorkingForemen();

    let foremenForDropdown = [];
    let workingForeForDropdown = [];
    let allForemen = [];

    if (fores.body) {
        foremenForDropdown = fores.body.map((foreman) => ({
            label: foreman.first_name + ' ' + foreman.last_name,
            value: foreman.id,
            id: foreman.id, 
            first_name: foreman.first_name,
            last_name: foreman.last_name
        }));
    }

    if (workingForemen.body) {
        workingForeForDropdown = workingForemen.body.map((foreman) => ({
            label: foreman.first_name + ' ' + foreman.last_name,
            value: foreman.id,
            id: foreman.id, 
            first_name: foreman.first_name,
            last_name: foreman.last_name
        }));
    }


    allForemen = [...foremenForDropdown, ...workingForeForDropdown];

    this.setState({
        foremenForDropdown,
        workingForeForDropdown,
        genericForemenToUseForDropdown: allForemen,
        allForemen, 
    });
}

async getConfigurableRoles() {
  this.setState({
    updating: true
  })

  const roles = await LineworxClient.getConfigurableRoles();
  if(roles.body) {
    let rolesForDropdown = roles.body.map((role) => {
      return {
          label:role.display_role_name,
          value:role.id
      }
    });
      this.setState({
        rolesForDropdown,
        updating: false
      });
  } else {
    this.setState({
      updating: false
    });
  }   
}

  updateSelectedStatus(e) {
    this.setState({
      selectedStatus: e.target.textContent,
    })
    // this.setState({
    //   selectedStatus: e.target.textContent
    // }, () => {
    //   let filteredCrew = this.filterTheseJobs(this.state.crew);
    //   this.setState({
    //     filteredCrew,
    //   });
    // });
  }

  async showAddUserModal() {
      let crewForEdit = {};
    this.setState({
      showAddUser: !this.state.showAddUser,
      newStatus: 1,
      crewForEdit
    })
  }

  dismissModal(isSaveAction=false) {
      if(!isSaveAction && this.state.isDirty) {
        if(window.confirm("You have unsaved changes. If you close you will lose these changes. Close anyway?")) {
            this.clearState()

            this.setState({
              showAddUser: false,
              showEditUser: false
            });
        }
      } else {
        this.clearState()
        this.setState({
            showAddUser: false,
            showEditUser: false
        });
    }
  }

//   getCrewObj(isUpdate){
//     let crew = {}
//     if(isUpdate) { crew.id = this.state.crewForEdit.id}
//     crew.crewStatus = this.state.newStatus 
//     crew.roleId = this.state.newSelectedRoleId 
//     crew.firstName = this.state.newFirstName 
//     crew.lastName = this.state.newLastName
//     crew.phone = this.state.newPhone 
//     crew.foreman = this.state.newForeId 
//     crew.email = this.state.newEmail
//     return crew
//   }

  async updateOrAddUser() {

    let isEditing = this.state.showEditUser

    //let crew = this.getCrewObj(isEditing)

    let resp = {}
    if (isEditing) {
      resp = await LineworxClient.updateCrew(this.state.crewForEdit);
    }
    else {
      resp = await LineworxClient.addCrew(this.state.crewForEdit);

    }

    if (resp.response.status === 200) {
      this.clearState()
      this.dismissModal(true)
      this.getCrew()
    }
    else {
      let msg = resp && resp.body && resp.body.status ? resp.body.status : "Error saving user"
      alert(msg)
    }
  


}


  clearState() {
    this.setState({      
        crewForEdit: {},
        emailError:false,
        canSave:false,
        isDirty:false

  })
  }

  showEditUserModal(e) {
    let crewId = 0
    if(e) crewId = Number(e.target.dataset.crew_id);

    console.log(crewId);
    console.log(e);
    let editCrew = this.state.crew.find(c => {
      return c.id === crewId;
    });

    if(!editCrew) return;
    let showEditUser = !this.state.showEditUser
    let crewForEdit = JSON.parse(JSON.stringify(editCrew));

    this.setState({
      showEditUser: showEditUser
    })

    if(showEditUser){
      this.setState({      
        crewForEdit
      })
    }
    else{
      this.dismissModal()
  }
}

  crewStatusChanged = async (event) => {
    let newStatus = this.state.crewForEdit.crew_status === 1 ? 2 : 1

    let crew = this.state.crewForEdit
    crew.crew_status = newStatus

    this.setState ({
        crewForEdit: crew
    }, () => {
        this.checkCanSave()
    });
  }

  handleRoleChange = async (event) => {
    const newSelectedRoleId = event.value;
    const newSelectedRoleName = event.label;
    let showForeman = false;
    let genericForemenToUseForDropdown = this.state.foremenForDropdown;
    // let crew = this.state.crewToEdit
    // if(newSelectedRoleName === "Working Foreman" || 
    // newSelectedRoleName === "Lineman" || 
    // newSelectedRoleName === "Apprentice") {
    //     showForeman = true;
    //     genericForemenToUseForDropdown = this.state.workingForeForDropdown;
    // }
    if(newSelectedRoleName === "Working Foreman") {
        genericForemenToUseForDropdown = this.state.foremenForDropdown;
    }

    console.log("Foreman");
    console.log(genericForemenToUseForDropdown);
    let crew = this.state.crewForEdit;
    crew.role_id = newSelectedRoleId
    crew.display_role_name = newSelectedRoleName

    this.setState ({
        crewForEdit: crew,
      genericForemenToUseForDropdown,
      showForeman
    }, () => {
        this.checkCanSave()
    });
  }

  handleFirstNameChange = async (event) => {
    const newFirstName = event.target.value;
    let crew = this.state.crewForEdit
    crew.first_name = newFirstName

    this.setState ({
        crewForEdit: crew
    }, () => {
        this.checkCanSave()
    });
  }

  handleLastNameChange = async (event) => {
    const newLastName = event.target.value;
    let crew = this.state.crewForEdit
    crew.last_name = newLastName
    
    this.setState ({
        crewForEdit: crew
    }, () => {
        this.checkCanSave()
    });
  }

  handlePhoneChange = async (event) => {
    const phone = event.target.value;
    let crew = this.state.crewForEdit
    crew.phone_number = phone
    
    this.setState ({
        crewForEdit: crew
    }, () => {
        this.checkCanSave()
    });
  }

  validateEmail= (text) => {
    //console.log(text);
    
    return reg.test(text);
  }

  handleEmailChange = async (event) => {
    const newEmail = event.target.value;
    let crewForEdit = this.state.crewForEdit;
    crewForEdit.email = newEmail;
    this.setState ({
        crewForEdit
    }, () => {
        this.checkCanSave()
    })
  }

  checkSaveErrors = (leaving) => {
      if(!leaving)return;

      let crewForEdit = this.state.crewForEdit;

      let emailError = this.state.emailError;
    if (leaving.target.id === "email") {
        if(!this.validateEmail(crewForEdit.email)) {
            emailError = true
        } else {
            emailError = false
        }
        this.setState({
            emailError
        });     
    }
    
    let phone = crewForEdit.phone_number;
    let phoneError = this.state.phoneError;
    if (leaving.target.id === "phone") {
        console.log(phone);
        if(phone && phone.length > 0 && phone.length !== 7 && phone.length !== 10) {
          
            phoneError=true;   
        } else {
            phoneError=false;   
        }
        this.setState({
            phoneError
        });      
    }

    let lname = crewForEdit.last_name;
    let lNameError = this.state.lNameError;
    if (leaving.target.id === "lName") {
        if(!lname || lname.length < 2) {
            lNameError=true;   
        } else {
            lNameError=false;   
        }
        this.setState({
            lNameError
        });      
    }

    let fname = crewForEdit.first_name;
    let fNameError = this.state.fNameError;
    if (leaving.target.id === "fName") {
        if(!fname || fname.length < 2) {
            fNameError=true;   
        } else {
            fNameError=false;   
        }
        this.setState({
            fNameError
        });      
    }

}

    checkIsDirty() {
        let original = this.state.crew.find((user) => {
            return user.id === this.state.crewForEdit.id
        })
        let crew = JSON.stringify(original);
        let crewEdit = JSON.stringify(this.state.crewForEdit);

        console.log(crew);
        console.log(crewEdit);
        let same = crew === crewEdit
        console.log(same);
        this.setState({
            isDirty: !same
        })
    }

  checkCanSave = () => {
    let canSave = true;

    let crewForEdit = this.state.crewForEdit;
    if(!this.validateEmail(crewForEdit.email)) {
        canSave=false;
    }
    let phone = crewForEdit.phone_number
    if(phone && (phone.length > 0 && phone.length !== 7 && phone.length !== 10)) {
        canSave=false;
    }

    let lname = crewForEdit.last_name;
    if(!lname || lname.length < 2 ) {
        canSave=false;
    }

    let fname = crewForEdit.first_name;
    if(!fname || fname.length < 2 ) {
        canSave=false;
    }

    if(!crewForEdit.role_id) {
        canSave = false;
    }

    if(this.state.showForeman && !crewForEdit.foreman_firstname) {
        canSave = false;
    }

    this.checkIsDirty()

      this.setState({
          canSave
      });

  }
  
  handleForemanChange = async (event) => {
    const newForeId = event.value;

    let allForeman = this.state.allForemen
    console.error("Foreman: ", allForeman);

    let selectedFore = allForeman.filter((fm) => fm.id === newForeId)[0]
    if (selectedFore === undefined) { return; }

    let crew = this.state.crewForEdit

    crew.foreman = selectedFore.id;
    crew.foreman_firstname = selectedFore.first_name;
    crew.foreman_lastname =selectedFore.last_name;

    this.setState ({
        crewForEdit: crew
    }, () => {
        this.checkCanSave()
    });
  }
 loadSortingDefaults() {
    /**
     * Retrieves the selected sort by and sort direction values from local storage.
     * If the values are not set in local storage, sets the default values.
     */
    const sortByValue = localStorage.getItem('sortByCrew');
    if (!sortByValue) {
      localStorage.setItem('sortByCrew', 'first_name');
    }   
    const sortDirValue = localStorage.getItem('sortDirCrew');
    if (!sortDirValue) {
      localStorage.setItem('sortDirCrew', 'desc');
    } 
}

  forgotPassword = async () => {
    let crew = this.state.crewForEdit

    if (crew.email === undefined) {
      alert("Must include an email address.");
      return;
    }

    await LineworxClient.forgotPassword(crew.email);
    
    alert("Have the user check their email for a link to reset their password");
  };
  

  render() {
    
    //roleId 3 is project manger, allow them as well as admin, owner and super admin 
    if (LineworxClient.canShowCrew()) {
      return (
        <div className="container-fluid px-0">
          <div
            className="loader-wrapper"
            hidden={this.state.updating === false} />
          
          <CSSTransition
            in={this.state.updating > 0}
            timeout={400}
            key={"loaderkey"}
            classNames="alert"
            unmountOnExit
          >
            <div className="loader"></div>
          </CSSTransition>
          
          {/* section - Page Header */}
          <Section>
            <div className="col py-5">
              <h1 className={styles.pageTitle}>Crew</h1>
            </div>
          </Section>
  
          
  
          {/* section - Table */}
          <Section>
            <div className="col">
              <div className="detail-section jobs-table-wrapper">
                {/* <CSSTransition in={this.state.jobs.length>0} key={"table"} timeout={1000} classNames="table-fade" mountOnEnter unmountOnExit> */}
                  <Table className="table table-striped">
                    <Thead>
                      <Tr>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'first_name')}><label>Name</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "first_name" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'display_role_name')}><label>Role</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "display_role_name" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'foreman_firstname')}><label>Crew</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "foreman_firstname" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        {/* <Th scope="col">Storm</Th> */}
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'phone_number')}><label>Cell #</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "phone_number" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'email')}><label>Email</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "email" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'status_name')}><label>Status</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "status_name" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                        <Th scope="col" onClick={() => this.handleSorting('sortDirCrew', 'sortByCrew', 'date_created')}><label>Date Added</label> <div className={(this.state.sort_dir==="asc"? "sort-asc" : "sort-desc") + (this.state.sort_col === "date_created" ? "" : ' hidden') + (' sort-icon')}  alt="Sort Direction"></div></Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      
                    
                      {
                       
                      this.state.crew.map((cr) => {
                        return (
                          <Tr key={cr.id} className="clickable-row" data-crew_id={cr.id} onClick={(e) => this.showEditUserModal(e)}>
                            <Td scope="row"><a data-crew_id={cr.id}>{cr.first_name} {cr.last_name}</a></Td>
                            {/* <Td>{cr.first_name} {cr.last_name}</Td>    */}
  
                            <Td data-crew_id={cr.id}>{cr.display_role_name}</Td>
                            <Td data-crew_id={cr.id}>{cr.foreman_firstname} {cr.foreman_lastname}</Td>
                            <Td data-crew_id={cr.id}>{cr.phone_number}</Td>
                            <Td data-crew_id={cr.id}>{cr.email}</Td>
                            <Td data-crew_id={cr.id}>{cr.status_name}</Td>
                            
  
                            {/* <Td>{cr.ticket_count}</Td> */}
                            
                            <Td data-crew_id={cr.id}>{cr.date_created ? new Intl.DateTimeFormat("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "2-digit"
                            }).format(new Date(cr.date_created)) : ''}</Td>
                            
                          </Tr>
                        )
                      })
                      } 
                      
                    </Tbody>
                  </Table>
                {/* </CSSTransition> */}
              </div>
            </div>
          </Section>
            
          {/* section - Btn Action */}
          <Section newClass="buttonAction">
            <div className="col">
              <div className="btn-action d-flex justify-content-end text-right">
                <button
                  type="button"
                  className={`btn btn-primary d-flex text-center text-white ${styles.btnIcon}`}
                  onClick={this.showAddUserModal}
                >
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 11 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 4H11V7L7 7V11H4V7L0 7V4.04102H4V0H7V4Z"
                      fill="white" />
                  </svg>
                  <span>Add User</span>
                </button>
              </div>
            </div>
          </Section>
  
  
  
          {(this.state.showEditUser || this.state.showAddUser) && 
            <div
              className={`modal fade show modalContain`}
              id="editUserModal"
              style={{display:"block"}}
              tabIndex="-1"
              aria-modal="true"
              role="dialog"
              aria-labelledby={`editUserModalLabel`}
              aria-hidden="true"
            >
              <div
                className={`modal-dialog modalDialog modal-lg modal-dialog-scrollable`}
                role="document"
              >
                <div className={`modal-content modalContent`}>
                  {/* <fieldset className="modalFieldset"> */}
  
                    {/* MODAL HEADER */}
                    <div className={`modal-header align-items-center modalHeader`}>
                      <h5
                        className={`modal-title modalTitle`}
                        id={`editUserModalLabel`}
                      >
                        {this.state.showEditUser ? 'Edit User' : 'Add User'}
              
                      </h5>
                      <button
                        type="button"
                        className={`close modalHeaderClose`}
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => this.dismissModal()}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
  
                    
                    {/* MODAL BODY */}
                    <div className={`modal-body modalBody`}>
                      
                      <div className="container-fluid">
                        
                        {/* section - Status / Role */}
                        <div className="row section sectionStatusRole">
  
                          {/* item - Status */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item status">
                            <label className="labelTitle lg">Status</label>
                            <label className="switch">
                          <input
                            type="checkbox"
                            checked={this.state.crewForEdit.crew_status === 1}
                            onChange={this.crewStatusChanged} />
                          <span className="slider round"></span>
                        </label>
                      </div>
  
                      {/* item - Role */}
                      <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item foreman">
                        <label className="labelTitle lg">Role*</label>
  
                        <div className="dropdown">
                          <Dropdown
                            options={this.state.rolesForDropdown}
                            onChange={this.handleRoleChange}
                            value={this.state.crewForEdit.display_role_name ? this.state.crewForEdit.display_role_name : ''}
                            placeholder="Select Role" />
                        </div>
  
                      </div>
  
                      {/* item - Role - Crew Foreman */}
                      <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item foreman ${this.state.showForeman || ["Lineman", "Apprentice", "Working Foreman"].includes(this.state.crewForEdit.display_role_name) ? '' : "hide"}`}>                        
                        <label className="labelTitle lg">Crew Foreman*</label>
                        <div className="dropdown">
                          <Dropdown
                            options={this.state.genericForemenToUseForDropdown}
                            onChange={this.handleForemanChange}
                            value={this.state.crewForEdit.foreman_firstname ? this.state.crewForEdit.foreman_firstname + ' ' + this.state.crewForEdit.foreman_lastname : ''}
                            placeholder="Select Foreman" />
                        </div>
  
                      </div>
                        
                        </div>
  
                        {/* section - Contact */}
                        <div className="row mb-0 section sectionContact">
                            
                          {/* item - First Name */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item fName">
                            <label
                              className="labelTitle lg"
                              htmlFor="fName"
                            >
                              First Name*
                            </label>
                            <input
                            value={this.state.crewForEdit.first_name ? this.state.crewForEdit.first_name : ''}
                              type="text"
                              name="fName"
                              id="fName"
                              onChange={this.handleFirstNameChange}
                              onBlur={(e) => this.checkSaveErrors(e)}
                            />
                          </div>
                          <span className={"error " + (this.state.fNameError?'' : 'hidden')} style={{textAlign:'right', width:'100%'}}>Enter a First Name</span>

                          {/* item - Last Name */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item lName">
                            <label
                              className="labelTitle lg"
                              htmlFor="lName"
                            >
                              Last Name*
                            </label>
                            <input
                             value={this.state.crewForEdit.last_name ? this.state.crewForEdit.last_name : ''}
                              type="text"
                              name="lName"
                              id="lName"
                              onChange={this.handleLastNameChange}
                              onBlur={(e) => this.checkSaveErrors(e)}
                            />
                          </div>
                          <span className={"error " + (this.state.lNameError?'' : 'hidden')} style={{textAlign:'right', width:'100%'}}>Enter a Last Name</span>

                          {/* item - Contact */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item phone">
                            <label
                              className="labelTitle lg"
                              htmlFor="phone"
                            >
                              Phone
                            </label>
                            <input
                            value={this.state.crewForEdit.phone_number ? this.state.crewForEdit.phone_number : ''}
                              type="text"
                              name="phone"
                              id="phone"
                              onChange={this.handlePhoneChange}
                              onBlur={(e) => this.checkSaveErrors(e)}
                            />
                          </div>
                          <span className={"error " + (this.state.phoneError?'' : 'hidden')} style={{textAlign:'right', width:'100%'}}>Enter a valid Phone Number</span>

                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item email">
                            <label
                              className="labelTitle lg"
                              htmlFor="email"
                            >
                              Email*
                            </label>
                            <input
                            value={this.state.crewForEdit.email ? this.state.crewForEdit.email : ''}
                              type="text"
                              name="email"
                              id="email"
                              readOnly={this.state.showEditUser}
                              onChange={this.handleEmailChange}
                              onBlur={(e) => this.checkSaveErrors(e)}
                            />
                            
                          </div>
                          <span className={"error " + (this.state.emailError?'' : 'hidden')} style={{textAlign:'right', width:'100%'}}>Enter a valid email address</span>
                          
                        </div>
  
                      </div>
            
                    </div>
                    
                    {/* MODAL FOOTER */}
                    <div className={`modal-footer modalFooter`}>
                    <button
                        type="button"
                        className={`btn btn-secondary modalFooterButton`}
                        data-dismiss="modal"
                        onClick={this.forgotPassword}
                      >
                        Reset Password
                      </button>

                      <button
                        type="button"
                        className={`btn btn-secondary modalFooterButton`}
                        data-dismiss="modal"
                        onClick={() => this.dismissModal()}
                      >
                        Close
                      </button>
  
                      <button
                        type="button"
                        className={`btn btn-primary modalFooterButton ${this.state.canSave?'':'disabled'}`}
                        disabled={!(this.state.canSave && this.state.isDirty)}
                        onClick={() => this.updateOrAddUser()}
                      >
                        Save
                      </button>
                    </div>
                  
                  {/* </fieldset> */}
                </div>
              </div>
            </div>
          }
  
        </div>      
    
      )}
    
    else {
      return null; 
    }
  }
}

export default Crew;